import React, { useState } from "react";
import { Mail, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const inputCls =
  "w-full bg-anthracite-900 border border-white/10 rounded-lg px-2.5 py-2 text-xs focus:border-electric outline-none";

export function PersonalQuoteRequestCard({ user }) {
  const [form, setForm] = useState({
    name: user?.name || "",
    email: user?.email || "",
    phone: user?.phone || "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/inquiries", {
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        message: `[Kereskedői ajánlatkérés]\n${form.message.trim()}`,
        car_id: null,
        car_label: "Kereskedői — személyes ajánlat",
      });
      toast.success("Ajánlatkérés elküldve — hamarosan jelentkezünk.");
      setForm((f) => ({ ...f, message: "" }));
    } catch {
      toast.error("Küldés sikertelen — próbáld újra.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      data-testid="personal-quote-card"
      onSubmit={submit}
      className="glass rounded-3xl p-6 flex flex-col h-full border border-white/10"
    >
      <div className="flex items-center gap-2 mb-2">
        <Mail className="w-5 h-5 text-electric" strokeWidth={1.5} />
        <span className="text-xs uppercase tracking-widest text-slate-400">Személyes ajánlat</span>
      </div>
      <h3 className="font-heading text-lg font-light leading-snug">Egyedi kereskedői csomag</h3>
      <p className="text-xs text-slate-500 mt-1 mb-3 line-clamp-2">
        Nagyobb flotta, több telephely vagy speciális igény — írj nekünk, összeállítjuk az ajánlatot.
      </p>

      <div className="space-y-2 flex-1 min-h-0">
        <input
          data-testid="quote-name"
          required
          placeholder="Név / cég"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className={inputCls}
        />
        <input
          data-testid="quote-email"
          type="email"
          required
          placeholder="E-mail"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className={inputCls}
        />
        <input
          data-testid="quote-phone"
          placeholder="Telefon"
          value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })}
          className={inputCls}
        />
        <textarea
          data-testid="quote-message"
          required
          rows={2}
          placeholder="Autók száma, telephelyek, igények…"
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          className={`${inputCls} resize-none`}
        />
      </div>

      <button
        type="submit"
        data-testid="quote-submit"
        disabled={loading}
        className="mt-auto pt-4 w-full inline-flex items-center justify-center gap-2 py-3 rounded-full bg-electric hover:bg-electric-light disabled:opacity-50 text-white text-sm font-medium transition-all shrink-0"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        Ajánlatot kérek
      </button>
    </form>
  );
}
